import { Flex, Box, Text } from '@cad-arc';

export function LocationSearchMapPlaceholder() {
    return (
        <Flex
            borderRadius="6px"
            w="250px"
            h="250px"
            backgroundColor="surface.background"
            justifyContent="center"
            alignItems="center"
        >
            <Box w="134px" textAlign="center">
                <Text variant="headingXs">Enter coordinates to view the map</Text>
            </Box>
        </Flex>
    );
}
